import React from 'react';
import PropTypes from 'prop-types';

import { LoaderBody } from "./styles";

const Loader = ({ style }) => (
  <LoaderBody style={style}>
    <div />
    <div />
    <div />
    <div />
  </LoaderBody>
);

Loader.propTypes = {
  style: PropTypes.instanceOf(Object),
};

export default Loader;
